import SymptomChecklist from './SymptomChecklist';
import CourseData from './CourseData';
import { AnswerSummary } from 'cccisd-laravel-appdefs/dist/reportTemplates';

export default [SymptomChecklist, CourseData, AnswerSummary];
